import {Address} from '@docma-mm-core/address/address';
import {Structure} from '@docma-mm-core/structure/structure';

export class StructureAddress {
  Id: number;
  Structure: Structure;
  Address: Address;
  AddressType: AddressTypeEnum;

  constructor(structureAddress: Partial<StructureAddress>) {
    if (structureAddress) {
      Object.assign(this, structureAddress);
      if (structureAddress.Structure) {
        // this.Structure = new Structure(structureAddress.Structure);
        this.Structure = structureAddress.Structure;
      }
      if (structureAddress.Address) {
        // this.Address = new Address(structureAddress.Address);
        this.Address = structureAddress.Address;
      }
    }
  }

}

export enum AddressTypeEnum {
  Renter = 0,
  Owner = 1,
  PropertyManager = 2
}
